import { RequiredIndicator } from './RequiredIndicator';

export const RequiredHelper = () => (
    <div className="card card-body shadow-sm rounded p-3 w-fit no-highlight">
        <div className="">
            <RequiredIndicator isOk={false} /> Mandatory field incomplete
        </div>

        <div className="mt-1">
            <RequiredIndicator isOk={true} /> Mandatory field complete
        </div>
    </div>
);